import { Grid, Button } from "@mui/material";
import React from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import {
  useListarEmpreendimentos2,
  useListarTorres,
  useOportunidadeLeadPost,
  useValidarCotacao,
} from "services/api";
import { AuthState } from "store/ducks/auth/types";

import { useListarBandeira } from "services/api/DadosComum/listar-bandeiras";
import { useListarEmpreendimentos2Filter } from "services/api/AppWeb_Empreendimento2/empreendimentosfilter";
import { set } from "date-fns";
import * as SVGIcons from "../../../../assets/iconsSVG";
import SelectComponent from "../../../selectAutoCompleteG";
import CustomInput from "./components/CustomInput";
import * as Styles from "./styles";

interface Props {
  idCorretor: string | undefined;
  idLead: string | undefined;
  closeModal: Function;
  closeOportunidades: Function;
  refetch: () => void;
  openSalesMirror: (val: any) => void;
}

const NewOportunityForm = (props: Props) => {
  const [product, setProduct] = React.useState<any>(null);
  const [bandeira, setBandeira] = React.useState<any>(null);
  const [salvarDisabled, setSalvarDisabled] = React.useState<boolean>(true);
  const [block, setBlock] = React.useState<any>(null);
  const { idCorretor2013 } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );

  const [idProposta, setIdProposta] = React.useState<string>("");

  const { data: bandeirasData, status: bandeirasStatus } = useListarBandeira();

  const {
    data: produtosData,
    refetch: produtosRefetch,
    status: produtosStatus,
    isFetching: produtosFetching,
  } = useListarEmpreendimentos2Filter({
    idBandeira365: bandeira?.value,
    espelhoVendas: true,
  });

  const {
    data: blocosData,
    refetch: blocosRefetch,
    status: blocosStatus,
    isFetching: blocosFetching,
  } = useListarTorres({
    idEmpreendimento: product?.value,
    queryKey: "listar-blocos",
  });

  const { refetch: cotacaoRefetch, status: cotacaoStatus } = useValidarCotacao({
    IdCotacao: idProposta,
    queryKey: "validar-cotacao-nova-oportunidade",
  });

  React.useEffect(() => {
    if (cotacaoStatus === "error") {
      setSalvarDisabled(true);
    }
    if (cotacaoStatus === "success") {
      setSalvarDisabled(false);
    }
    if (cotacaoStatus === "loading") {
      setSalvarDisabled(true);
    }
  }, [cotacaoStatus]);

  const mutation = useOportunidadeLeadPost({
    idLead: props.idLead,
    numeroCotacao: idProposta,
    onSuccess: () => {
      props.closeModal();
      props.closeOportunidades();
      // window.location.reload();
    },
  });

  // React.useEffect(() => {
  //   blocosRefetch();
  //   setBlock(null);
  // }, [product]);

  const handleChangeProduct = async (event: any) => {
    await setProduct(event);
    blocosRefetch();
    setBlock(null);
  };

  const handleChangeBandeira = async (event: any) => {
    await setBandeira(event);
    produtosRefetch();
    setProduct(null);
    setBlock(null);
  };

  // React.useEffect(() => {
  //   produtosRefetch();
  //   setProduct(null);
  // }, [bandeira]);

  // React.useEffect(() => {
  //   produtosRefetch();
  // }, [bandeira]);

  React.useEffect(() => {
    if (idProposta) {
      cotacaoRefetch();
    }
  }, [idProposta]);

  // const espelhoAnchorLink =
  //   block && product
  //     ? `https://pvcrm.cyrela.com.br/secretaria/FrmEspelhoVenda.aspx?id=${product?.value}&ambiente=6&idBloco=${block?.value}&sec=N&dt=N`
  //     : `https://pvcrm.cyrela.com.br/secretaria/FrmEmpreendimento.aspx?userid=${idCorretor2013}&tipoUrl=6`;

  const handleSave = () => {
    setSalvarDisabled(true);
    mutation.mutate({ numeroCotacao: idProposta });
  };

  React.useEffect(() => {
    if (mutation.isSuccess) {
      props?.refetch();
    }
  }, [mutation.isSuccess]);

  return (
    <Styles.Container>
      {/* <Styles.Title>Nova oportunidade</Styles.Title>
      <Styles.LightText>Crie oportunidades para o seu lead</Styles.LightText>
      <Styles.SpaceY space={20} /> */}
      <Styles.Divider>
        <Styles.LightText
          style={{
            background: "white",
            width: "30%",
            margin: "8px auto 0",
            color: "#424248",
            fontSize: "1rem",
          }}
        >
          Escolher unidade
        </Styles.LightText>
      </Styles.Divider>

      <SelectComponent
        borderRadius="8px"
        data={
          bandeirasStatus === "success"
            ? bandeirasData?.map((item: any) => ({
                label: item?.nome,
                value: item?.id,
              }))
            : []
        }
        label="Filtrar bandeira"
        value={bandeira}
        onChange={(event: { label: string; value: string }) => {
          handleChangeBandeira(event);
        }}
      />

      <Styles.SpaceY space={20} />
      <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
        <SelectComponent
          borderRadius="8px"
          data={
            produtosStatus === "success"
              ? produtosData?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                  codigoSap: item?.codigoSap,
                }))
              : []
          }
          label="Produtos"
          value={product}
          disabled={produtosFetching}
          onChange={(event: { label: string; value: string }) => {
            handleChangeProduct(event);
          }}
        />
        {blocosStatus === "error" ? <p style={{ color: "red" }} /> : null}

        <Styles.SpaceY space={20} />

        <SelectComponent
          borderRadius="8px"
          data={
            blocosStatus === "success"
              ? blocosData?.data?.map((item: any) => ({
                  label: item?.nome,
                  value: item?.id,
                }))
              : []
          }
          label="Blocos"
          value={block}
          disabled={blocosFetching || !product}
          onChange={(event: { label: string; value: string }) => {
            setBlock(event);
          }}
        />

        {blocosStatus === "error" ? <p style={{ color: "red" }} /> : null}
      </div>

      <Styles.SpaceY space={20} />
      <Styles.GradientButton
        disabled={!product || !block}
        onClick={() => {
          props?.openSalesMirror({
            bandeira,
            produto: product,
            bloco: block,
            blocosData,
          });
        }}
      >
        Espelho de vendas <SVGIcons.SharedIcon style={{ marginLeft: 8 }} />
      </Styles.GradientButton>

      <Styles.SpaceY space={20} />
      <Styles.Divider>
        <Styles.LightText
          style={{
            background: "white",
            width: "30%",
            margin: "8px auto 0",
            color: "#424248",
            fontSize: "1rem",
          }}
        >
          Vincular cotação
        </Styles.LightText>
      </Styles.Divider>
      <CustomInput
        label="ID da proposta"
        status={cotacaoStatus}
        value={idProposta}
        onChange={(e: string) => setIdProposta(e)}
      />
      <Styles.SpaceY space={20} />
      {/* <CustomUpload label="Anexo" onUpload={(file) => console.log(file)} /> */}
      <Styles.SpaceY space={20} />
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <Button
            fullWidth
            variant="outlined"
            style={{
              borderColor: "#424248",
              color: "#424248",
              height: 40,
              textTransform: "none",
            }}
            onClick={() => props.closeModal()}
          >
            Cancelar
          </Button>
        </Grid>
        <Grid item xs={6}>
          <Button
            style={{
              backgroundColor: "#2D5BFF",
              height: 40,
              textTransform: "none",
              color: "white",
              opacity: salvarDisabled ? 0.7 : 1,
            }}
            fullWidth
            variant="contained"
            disabled={salvarDisabled}
            onClick={handleSave}
          >
            Vincular Cotação
          </Button>
        </Grid>
      </Grid>
    </Styles.Container>
  );
};

export default NewOportunityForm;
